import googleAnalytics from './googleAnalytics';
import googleAnalyticsAdapterProvider from './googleAnalyticsAdapterProvider';
import segmentIOAdapterProvider from './SegmentIOAdapterProvider';
import consoleLogAdapter from 'gw-portals-tracking-js/adapters/ConsoleLogAdapter';
import localStorageAdapter from 'gw-portals-tracking-js/adapters/LocalstorageAdapter';
//AMA
import googleTagManager from './googleTagManager';
import googleTagManagerAdapterProvider from './googleTagManagerAdapterProvider';
import altocloudAnalytics from './AltocloudAnalytics';
import altocloudAnalyticsAdapterProvider from './AltocloudAnalyticsAdapterProvider';
import '../../gw-portals-tracking-angular';

angular.module('gw-portals-tracking-angular.adapters', []).factory('googleAnalytics', googleAnalytics).factory('googleTagManager', ['ama.AppConfig', googleTagManager]).factory('altocloudAnalytics', ['ama.AppConfig', altocloudAnalytics])
//.factory('googleTagManager', googleTagManager)
.provider('adapters.altocloudAnalytics', altocloudAnalyticsAdapterProvider).provider('adapters.googleTagManager', googleTagManagerAdapterProvider).provider('adapters.googleAnalytics', googleAnalyticsAdapterProvider).provider('adapters.segmentIO', segmentIOAdapterProvider).value('adapters.console', consoleLogAdapter).value('adapters.localstorage', localStorageAdapter);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-tracking-angular/adapters/module.js
// module id = 914
// module chunks = 0